import { Grid, Typography } from "@mui/material";

interface NoTableDataProps {
    title: string;
    subtitle?: string;
}

const NoTableData = ({ title, subtitle }: NoTableDataProps) => (
    <Grid
        container
        xs
        textAlign={'center'}
        justifyContent={'center'}
        alignItems={'center'}
        direction={'column'}
    >
        <Typography variant="subtitle1" fontSize={'20px'} maxWidth={'60%'}>
            {title}
        </Typography>
        <Typography fontSize={16} color={'#384A52'} variant="h4" mt={0} pt={0} maxWidth={'580px'}>
        {subtitle}
        </Typography>
    </Grid>
);

export default NoTableData;